import { render, staticRenderFns } from "./form_checkbox.vue?vue&type=template&id=77700a13&scoped=true&lang=pug"
import script from "./form_checkbox.vue?vue&type=script&lang=js"
export * from "./form_checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77700a13",
  null
  
)

export default component.exports